import { sendLogEvent } from '@/utils/functions/tracking/sendLogEvent';

type QpsTrackingEvent =
  | 'questionnaire_affiche'
  | 'questionnaire_reussi'
  | 'questionnaire_echoue'
  | 'questionnaire_indisponible'
  | 'nouvel_essai'
  | 'retour_proposition'
  | 'nous_contacter'
  | 'contact_chat'
  | 'contact_telephone'
  | 'contact_email';

interface QpsTrackingContext {
  // Code support du questionnaire ; le slug du produit quand l'indisponibilité n'en donne pas.
  codeSupport: string;
  // Numéro de tentative affiché, à partir de 1. Absent quand aucun questionnaire n'a été passé.
  attempt?: number;
}

const DISPLAY_EVENTS = new Set<QpsTrackingEvent>([
  'questionnaire_affiche',
  'questionnaire_reussi',
  'questionnaire_echoue',
  'questionnaire_indisponible',
]);

const trackQps = (event: QpsTrackingEvent, { codeSupport, attempt }: QpsTrackingContext) => {
  const type = DISPLAY_EVENTS.has(event) ? 'affichage' : 'clic';
  void sendLogEvent(type, {
    event_id: type,
    event_categorie: type,
    event_metier: 'placement',
    event_nom: event,
    event_detail_1: codeSupport,
    event_detail_2: attempt === undefined ? 'indisponible' : `tentative_${attempt}`,
  });
};

export default trackQps;
